export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f1a3a4397e9bdd58d006a3f5478c1ef5af863e092&name=fetchTypeahead!'